<template>
  <div>
    <RevDivider class="my-16" />
    <div class="flex items-center justify-between">
      <div>
        <p class="text-static-default-low caption">
          {{ title }}
        </p>
        <slot>
          <p class="body-2 mt-8">
            {{ subtitle }}
          </p>
        </slot>
      </div>
      <p class="body-2-bold self-end">
        {{ price }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevDivider } from '@ds/components/Divider'

defineProps<{
  title?: string
  subtitle?: string
  price?: string
}>()
</script>
